import { render } from "./ModularList.vue?vue&type=template&id=26feb8d6&scoped=true"
import script from "./ModularList.vue?vue&type=script&lang=js"
export * from "./ModularList.vue?vue&type=script&lang=js"

import "./ModularList.vue?vue&type=style&index=0&id=26feb8d6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26feb8d6"]])

export default __exports__